import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Layout from "../views/Layout.vue";

import Quotes from "../views/Quotes.vue";

import Banners from "../views/Banners.vue";
import PopUpBannersDetail from "../views/Banners/PopUp/PopUpBannersDetail.vue";
import PopUpBannersCreate from "../views/Banners/PopUp/PopUpBannersCreate.vue";
import PopUpBannersEdit from "../views/Banners/PopUp/PopUpBannersEdit.vue";

import HorizontalBannersCreate from "../views/Banners/Horizontal/HorizontalBannersCreate.vue";
import HorizontalBannersDetail from "../views/Banners/Horizontal/HorizontalBannersDetail.vue";
import HorizontalBannersEdit from "../views/Banners/Horizontal/HorizontalBannersEdit.vue";

import NewsBannersCreate from "../views/Banners/News/NewsBannersCreate.vue";
import NewsBannersDetail from "../views/Banners/News/NewsBannersDetail.vue";
import NewsBannersEdit from "../views/Banners/News/NewsBannersEdit.vue";
import EventsBannerCreate from "../views/Banners/Events/EventsBannerCreate.vue";
import EventsBannerDetail from "../views/Banners/Events/EventsBannerDetail.vue";
import EventsBannerEdit from "../views/Banners/Events/EventsBannerEdit.vue";

import News from "../views/News.vue";
import NewsCreate from "../views/News/NewsCreate.vue";
import NewsDetail from "../views/News/NewsDetail.vue";
import NewsEdit from "../views/News/NewsEdit.vue";

import Categories from "../views/Categories.vue";
import CreateCategories from "../views/Categories/CreateCategories.vue";
import EditCategories from "../views/Categories/EditCategories.vue";

import Users from "../views/Users.vue";
import User from "../views/User.vue";

import Push from "../views/Notifications/Push.vue";
import SMS from "../views/Notifications/SMS.vue";
import Mail from "../views/Notifications/Mail.vue";

import AppSections from "../views/AppSections.vue";
import CreateAppSection from "../views/AppSections/CreateAppSection.vue";
import EditAppSection from "../views/AppSections/EditAppSection.vue";

import Shareholders from "../views/Shareholders.vue";
import CreateShareholder from "../views/Shareholder/CreateShareholder.vue";
import DetailShareholder from "../views/Shareholder/DetailShareholder.vue";
import EditShareholder from "../views/Shareholder/EditShareholder.vue";

import Events from "../views/Events.vue";
import CreateEvent from "../views/Events/CreateEvent.vue";
import DetailEvent from "../views/Events/DetailEvent.vue";
import EventBadgeConstructor from "../views/Events/EventBadgeConstructor.vue";
import EditEvent from "../views/Events/EditEvent.vue";

import CouncilActivity from "../views/CouncilActivity.vue";
import EditWorkPlan from "../views/CouncilActivity/EditWorkPlan.vue";
import EditActivityImage from "../views/CouncilActivity/EditActivityImage.vue";
import CreateMeeting from "../views/CouncilActivity/Meetings/CreateMeeting.vue";
import DetailMeeting from "../views/CouncilActivity/Meetings/DetailMeeting.vue";
import EditMeeting from "../views/CouncilActivity/Meetings/EditMeeting.vue";
import CreateFolderBlockOther from "../views/CouncilActivity/Other/CreateFolderBlockOther.vue";
import DetailFolderOther from "../views/CouncilActivity/Other/DetailFolderOther.vue";
import EditFolderBlockOther from "../views/CouncilActivity/Other/EditFolderBlockOther.vue";
import CreateFolderOther from "../views/CouncilActivity/Other/CreateFolderOther.vue";
import EditFolderOther from "../views/CouncilActivity/Other/EditFolderOther.vue";

import Regions from "../views/Settings/Regions.vue";
import Setting from "../views/Settings/Setting.vue";
import LettersEvents from "../views/Notifications/LettersEvents.vue";
import LettersEvent from "../views/Notifications/LettersEvent.vue";

import Constructor from "../views/Constructor.vue";
import PageConstructor from "../views/Constructor/PageConstructor.vue";
import AddBlockConstructor from "../views/Constructor/AddBlockConstructor.vue";
import DetailBlockConstructor from "../views/Constructor/DetailBlockConstructor.vue";
import EditBlockConstructor from "../views/Constructor/EditBlockConstructor.vue";

import ChatList from "../views/ClubShareholders/ChatList.vue";
import Chat from "../views/ClubShareholders/Chat.vue";
import ChatUsers from "../views/ClubShareholders/ChatUsers.vue";
import ChatUser from "../views/ClubShareholders/ChatUser.vue";
import ChatSettings from "../views/ClubShareholders/ChatSettings.vue";

import SystemUsers from "../views/SystemUsers/SystemUsers.vue";
import SystemRoles from "../views/SystemUsers/SystemRoles.vue";

import QuorumUsers from "../views/Quorum/Users.vue";
import QuorumUser from "../views/Quorum/User.vue";
import QuorumPush from "../views/Quorum/Push.vue";

import Appeal from "../views/Appeal.vue";
import AppealUser from "../views/Appeal/AppealUser.vue";
import AppelaUserDetail from "../views/Appeal/AppelaUserDetail.vue";
import SupportAppeal from "../views/Appeal/SupportAppeal.vue";
import SocialAppeal from "../views/Appeal/SocialAppeal.vue";
import Link from "../views/Appeal/Link.vue";
import LinkDetail from "../views/Appeal/LinkDetail.vue";

import Bulletins from "../views/Bulletins.vue";

import Polls from "../views/Polls.vue";
import PollDetail from "../views/Polls/PollDetail.vue";
import PollCreateEdit from "../views/Polls/PollCreateEdit.vue";
import License from "../views/License.vue";
import DataProcessingAgreement from "../views/DataProcessingAgreement.vue";

import Privileges from "../views/Privileges/Privileges.vue";
import Trainings from "../views/Trainings/Trainings.vue";

import Candidates from "../views/ElectionsKSA/CandidatesKSA.vue";
import SelectionBlocks from "../views/ElectionsKSA/SelectionBlocks.vue";
import CreateCandidate from "../views/ElectionsKSA/CandidatesPages/CreateCandidate.vue";
import DetailCandidate from "../views/ElectionsKSA/CandidatesPages/DetailCandidate.vue";
import EditCandidate from "../views/ElectionsKSA/CandidatesPages/EditCandidate.vue";

import Stories from "../views/Stories.vue";

Vue.use(VueRouter);
import store from "../store/index";
const routes = [
  {
    path: "/",
    component: Layout,
    async beforeEnter(to, from, next) {
      if (await store.dispatch("authorizationAdminPanel")) {
        next();
      } else {
        next({ name: "login" });
      }
    },
    children: [
      {
        path: "quotes",
        name: "Quotes",
        component: Quotes,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners",
        name: "Banners",
        component: Banners,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/popup-detail/:id",
        name: "PopUpBannersDetail",
        component: PopUpBannersDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/popup-create",
        name: "PopUpBannersCreate",
        component: PopUpBannersCreate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/popup-edit/:id",
        name: "PopUpBannersEdit",
        component: PopUpBannersEdit,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/horizontal-create",
        name: "HorizontalBannersCreate",
        component: HorizontalBannersCreate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/horizontal-detail/:id",
        name: "HorizontalBannersDetail",
        component: HorizontalBannersDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/horizontal-edit/:id",
        name: "HorizontalBannersEdit",
        component: HorizontalBannersEdit,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "banners/news-create",
        name: "NewsBannersCreate",
        component: NewsBannersCreate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/news-detail/:id",
        name: "NewsBannersDetail",
        component: NewsBannersDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/news-edit/:id",
        name: "NewsBannersEdit",
        component: NewsBannersEdit,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "banners/event-create",
        name: "EventsBannerCreate",
        component: EventsBannerCreate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "banners/event-detail/:id",
        name: "EventsBannerDetail",
        component: EventsBannerDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "banners/event-edit/:id",
        name: "EventsBannerEdit",
        component: EventsBannerEdit,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("main_page")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "news",
        name: "News",
        component: News,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("news")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "news/create",
        name: "NewsCreate",
        component: NewsCreate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("news")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "news/:id",
        name: "NewsDetail",
        component: NewsDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("news")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "news/edit/:id",
        name: "NewsEdit",
        component: NewsEdit,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("news")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "categories",
        name: "Categories",
        component: Categories,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("news")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "categories/create",
        name: "CreateCategories",
        component: CreateCategories,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("news")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "categories/edit/:id",
        name: "EditCategories",
        component: EditCategories,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("news")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "users",
        name: "Users",
        component: Users,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("mobile_users")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "user/:id",
        name: "User",
        component: User,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("mobile_users")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appsections",
        name: "AppSections",
        component: AppSections,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("menu_items")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appsection/create",
        name: "CreateAppSection",
        component: CreateAppSection,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("menu_items")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appsection/edit/:id",
        name: "EditAppSection",
        component: EditAppSection,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("menu_items")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "push",
        name: "Push",
        component: Push,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("notifications")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "sms",
        name: "SMS",
        component: SMS,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("notifications")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "mail",
        name: "Mail",
        component: Mail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("notifications")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      //KSA ELECTIONS
      {
        path: "candidates",
        name: "Candidates",
        component: Candidates,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksaElection")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "candidates/create",
        name: "CreateCandidate",
        component: CreateCandidate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksaElection")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "candidates/detail/:id",
        name: "DetailCandidate",
        component: DetailCandidate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksaElection")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "candidates/edit/:id",
        name: "EditCandidate",
        component: EditCandidate,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksaElection")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "selection",
        name: "SelectionBlocks",
        component: SelectionBlocks,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksaElection")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "voting-broadcast",
        name: "VotingBroadcast",
        component: () => import("../views/VotingBroadcast/VotingBroadcast.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("events")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "voting-broadcast/edit/:id?",
        name: "VotingBroadcastEdit",
        component: () =>
          import("../views/VotingBroadcast/VotingBroadcastEdit.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("events")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "shareholders",
        name: "Shareholders",
        component: Shareholders,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "shareholder/create",
        name: "CreateShareholder",
        component: CreateShareholder,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "shareholder/detail/:id",
        name: "DetailShareholder",
        component: DetailShareholder,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "shareholder/edit/:id",
        name: "EditShareholder",
        component: EditShareholder,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "events",
        name: "Events",
        component: Events,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("events")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "event/create",
        name: "CreateEvent",
        component: CreateEvent,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("events")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "event/detail/:id",
        name: "DetailEvent",
        component: DetailEvent,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("events")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "event/badge/:id",
        name: "EventBadgeConstructor",
        component: EventBadgeConstructor,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("events")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "event/edit/:id",
        name: "EditEvent",
        component: EditEvent,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("events")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity",
        name: "CouncilActivity",
        component: CouncilActivity,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/workplan/edit",
        name: "EditWorkPlan",
        component: EditWorkPlan,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/images/:key/edit",
        name: "EditActivityImage",
        component: EditActivityImage,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/meeting/create",
        name: "CreateMeeting",
        component: CreateMeeting,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/meeting/:id",
        name: "DetailMeeting",
        component: DetailMeeting,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/meeting/edit/:id",
        name: "EditMeeting",
        component: EditMeeting,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/folder/:id/block/create",
        name: "CreateFolderBlockOther",
        component: CreateFolderBlockOther,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/folder/:id/block/:idBlock",
        name: "EditFolderBlockOther",
        component: EditFolderBlockOther,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "councilactivity/folder/create",
        name: "CreateFolderOther",
        component: CreateFolderOther,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "councilactivity/folder/:id",
        name: "EditFolderOther",
        component: EditFolderOther,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "councilactivity/folder/:id",
        name: "DetailFolderOther",
        component: DetailFolderOther,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "regions",
        name: "Regions",
        component: Regions,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("settings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "setting",
        name: "Setting",
        component: Setting,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("settings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "letters",
        name: "LettersEvents",
        component: LettersEvents,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("notifications")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "letters/event/:id",
        name: "LettersEvent",
        component: LettersEvent,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("notifications")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "analytics",
        name: "Constructor",
        component: Constructor,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("pages")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "analytics/page/:id",
        name: "PageConstructor",
        component: PageConstructor,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("pages")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "analytics/page/:id/block/add",
        name: "AddBlockConstructor",
        component: AddBlockConstructor,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("pages")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "analytics/page/:id/block/:idBlock",
        name: "DetailBlockConstructor",
        component: DetailBlockConstructor,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("pages")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "analytics/page/:id/block/edit/:idBlock",
        name: "EditBlockConstructor",
        component: EditBlockConstructor,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("pages")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "chatlist",
        name: "ChatList",
        component: ChatList,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("shareholders_club")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "chatlist/chat/:id",
        name: "Chat",
        component: Chat,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("shareholders_club")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "chatusers",
        name: "ChatUsers",
        component: ChatUsers,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("shareholders_club")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "chatusers/user/:id",
        name: "ChatUser",
        component: ChatUser,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("shareholders_club")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "chatsettings",
        name: "ChatSettings",
        component: ChatSettings,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("shareholders_club") &&
            store.getters.editRoleUser("shareholders_club")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "systemroles",
        name: "SystemRoles",
        component: SystemRoles,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("system_users")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "systemusers",
        name: "SystemUsers",
        component: SystemUsers,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("system_users")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      // {
      //   path: "quorumUsers",
      //   name: "QuorumUsers",
      //   component: QuorumUsers,
      //   async beforeEnter(to, from, next) {
      //     if (
      //       (await store.dispatch("authorizationAdminPanel")) &&
      //       store.getters.visiblePage("quorum")
      //     ) {
      //       next();
      //     } else {
      //       next({ name: "login" });
      //     }
      //   },
      // },
      // {
      //   path: "quorum/user/:id",
      //   name: "QuorumUser",
      //   component: QuorumUser,
      //   async beforeEnter(to, from, next) {
      //     if (
      //       (await store.dispatch("authorizationAdminPanel")) &&
      //       store.getters.visiblePage("quorum")
      //     ) {
      //       next();
      //     } else {
      //       next({ name: "login" });
      //     }
      //   },
      // },

      // {
      //   path: "quorumPush",
      //   name: "QuorumPush",
      //   component: QuorumPush,
      //   async beforeEnter(to, from, next) {
      //     if (
      //       (await store.dispatch("authorizationAdminPanel")) &&
      //       store.getters.visiblePage("quorum")
      //     ) {
      //       next();
      //     } else {
      //       next({ name: "login" });
      //     }
      //   },
      // },
      {
        path: "appeal",
        name: "Appeal",
        component: Appeal,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/user/create",
        name: "AppealUserCreate",
        component: AppealUser,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/user/edit/:id",
        name: "AppealUserEdit",
        component: AppealUser,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/user/:id",
        name: "AppelaUserDetail",
        component: AppelaUserDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/support/create",
        name: "SupportAppealCreate",
        component: SupportAppeal,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/support/edit/:id",
        name: "SupportAppealEdit",
        component: SupportAppeal,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/social/create",
        name: "SocialAppealCreate",
        component: SocialAppeal,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/support/edit/:id",
        name: "SocialAppealEdit",
        component: SocialAppeal,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/link/create",
        name: "LinkCreate",
        component: Link,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/link/edit/:id",
        name: "LinkEdit",
        component: Link,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "appeal/link/:id",
        name: "LinkDetail",
        component: LinkDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("appeals")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "bulletins",
        name: "Bulletins",
        component: Bulletins,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("bulletin")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "polls",
        name: "Polls",
        component: Polls,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("polls")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "poll/information/:id",
        name: "PollDetail",
        component: PollDetail,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("polls")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "poll/create",
        name: "PollCreate",
        component: PollCreateEdit,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("polls")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "poll/edit/:id",
        name: "PollEdit",
        component: PollCreateEdit,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("polls")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "privileges",
        name: "Privileges",
        component: Privileges,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "privileges/add",
        name: "AddPrivilegies",
        component: () => import("../views/Privileges/AddEditPrivileges"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "privileges/edit/:id",
        name: "EditPrivilegies",
        component: () => import("../views/Privileges/AddEditPrivileges"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "privileges/detail/:id",
        name: "DetailPrivilleges",
        component: () => import("../views/Privileges/DetailPrivilleges"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "trainings",
        name: "Trainings",
        component: Trainings,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "trainings/training/:id?",
        name: "Training",
        component: () => import("../views/Trainings/AddEditTrainings.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "stories",
        name: "Stories",
        component: Stories,
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("stories")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "stories/story/:id?",
        name: "StoryCreate",
        component: () => import("../views/Stories/StoryAddEdit.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("stories")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/questions",
        name: "ConferenceQuestions",
        component: () => import("../views/Conferences/ConferenceQuestions.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/reactions",
        name: "Reactions",
        component: () => import("../views/Conferences/ConferenceReactions"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/:id/reactions",
        name: "ReactionsConference",
        component: () => import("../views/Conferences/ReactionsConference"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conferences/reaction/:id",
        name: "ReactionsConferences",
        component: () => import("../views/Conferences/ConferencesReaction"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("ksa")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/actual",
        name: "ConferenceActual",
        component: () => import("../views/Conferences/ConferenceActual"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/create",
        name: "ConferenceCreate",
        component: () => import("../views/Conferences/ConferenceCreate"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/archival",
        name: "ConferenceArchive",
        component: () => import("../views/Conferences/ConferenceArchive"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/archive/:id?",
        name: "ConferenceArchiveId",
        component: () => import("../views/Conferences/ConferenceActual"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/information",
        name: "ConferenceInformation",
        component: () =>
          import("../views/Conferences/ConferenceInformation.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/experts",
        name: "ConferenceExperts",
        component: () => import("../views/Conferences/ConferenceExperts.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/moderators",
        name: "ConferenceModerators",
        component: () => import("../views/Conferences/ConferenceModerator"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/question/:id?",
        name: "AddEditQuestion",
        component: () => import("../views/Conferences/AddEditQuestion.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "detail/expert/:id",
        name: "DetailExpert",
        component: () => import("../views/Conferences/DetailExpert.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "detail/moderator/:id",
        name: "DetailModerator",
        component: () => import("../views/Conferences/DetailModerator"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/:conferenceId/expert/:id?",
        name: "AddEditExpert",
        component: () => import("../views/Conferences/AddEditExpert.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/:conferenceId/moderator/:id?",
        name: "AddEditModerator",
        component: () => import("../views/Conferences/AddEditModerator.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/blocks",
        name: "ConferenceBlocks",
        component: () => import("../views/Conferences/ConferenceBlocks.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/block/:id?",
        name: "AddEditBlock",
        component: () => import("../views/Conferences/AddEditBlock.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "conference/statistics",
        name: "ConferenceStatistics",
        component: () =>
          import("../views/Conferences/ConferenceStatistics.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("conferences")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "dividends",
        name: "Dividends",
        component: () => import("../views/Dividends.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("dividends")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "dividends/dividend/:id?",
        name: "Dividend",
        component: () => import("../views/Dividends/AddEditDividend.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("dividends")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "dividends/dividend/:id?",
        name: "BlockDividend",
        component: () => import("../views/Dividends/AddEditBlockDividend.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("dividends")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "dividends/dividend-block/detail/:id",
        name: "BlockDividendDetail",
        component: () => import("../views/Dividends/BlockDividendDetail.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("dividends")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "dividends/dividend-block/:id?",
        name: "AddEditBlockDividend",
        component: () => import("../views/Dividends/AddEditBlockDividend.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("dividends")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities",
        name: "Activities",
        component: () => import("../views/Activities.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/activity",
        name: "Activity",
        component: () => import("../views/Activities/ActivityAdd.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activity/actual",
        name: "ActivityActual",
        component: () => import("../views/Activities/ActivitiesMain.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activity/monitor",
        name: "ActivityMonitorContent",
        component: () =>
          import("../views/Activities/ActivityMonitorContent.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/information",
        name: "ActivityInformation",
        component: () => import("../views/Activities/ActivityInformation.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "activities/non-actual/:id",
        name: "ActivityNotActual",
        component: () => import("../views/Activities/ActivitiesMain.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id?",
        name: "Activity",
        component: () => import("../views/Activities/Activity.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/map/add",
        name: "ActivityAddMap",
        component: () => import("../views/Activities/ActivityAddMap"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "activities/:id/map/:idmap/edit",
        name: "ActivityEditMap",
        component: () => import("../views/Activities/ActivityAddMap"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/block/:idblock/edit",
        name: "ActivityEditBlock",
        component: () => import("../views/Activities/ActivityBlockEdit"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/map/:idmap",
        name: "ActivityMap",
        component: () => import("../views/Activities/ActivityMap"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/translations",
        name: "ActivityTranslationsEdit",
        component: () => import("../views/Activities/ActivityTranslationEdit"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/offersAdd",
        name: "ActivityOfferAdd",
        component: () => import("../views/Activities/ActivityAddOrEditOffers"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/agendaAdd",
        name: "ActivityAgendaAdd",
        component: () => import("../views/Activities/ActivityAgendaAddOrrEdit"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/agenda/:idAgenda/edit",
        name: "ActivityAgendaEdit",
        component: () => import("../views/Activities/ActivityAgendaAddOrrEdit"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },

      {
        path: "activities/:id/offer/:idoffer/edit",
        name: "ActivityOfferEdit",
        component: () => import("../views/Activities/ActivityAddOrEditOffers"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/photo",
        name: "ActivityAddPhone",
        component: () => import("../views/Activities/ActivityAddorEditPhone"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/consulzone",
        name: "ActivityConsulZone",
        component: () => import("../views/Activities/ActivityConsulZone"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/consulzone/:idzone/edit",
        name: "ActivityConsulZoneEdit",
        component: () =>
          import("../views/Activities/ActivityAddOrEditConsulZone"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/consulzone/add",
        name: "ActivityConsulZoneAdd",
        component: () =>
          import("../views/Activities/ActivityAddOrEditConsulZone"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/photo/:idphoto",
        name: "ActivityEditPhone",
        component: () => import("../views/Activities/ActivityAddorEditPhone"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/map/:idmap/addzone",
        name: "ActivityAddZone",
        component: () => import("../views/Activities/ActivityAddZone"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id/map/:idmap/editzone/:idzone",
        name: "ActivityEditZone",
        props: {
          isEdit: true,
        },
        component: () => import("../views/Activities/ActivityAddZone"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id?/question/:questionId?",
        name: "ActivityQuestion",
        component: () => import("../views/Activities/ActivityQuestion.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id?/speaker/:speakerId?",
        name: "ActivitySpeaker",
        component: () => import("../views/Activities/ActivitySpeaker.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id?/member/:memberId?",
        name: "ActivityMember",
        component: () => import("../views/Activities/ActivityMember.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id?/member/:memberId?/edit",
        name: "ActivityMemberEdit",
        component: () => import("../views/Activities/ActivityMemberEdit.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "activities/:id?/member/:memberId?/badge/edit",
        name: "ActivityMemberBadgeEdit",
        component: () =>
          import("../views/Activities/ActivityMemberBadgeEdit.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("meetings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "topics-questions",
        name: "TopicsQuestions",
        component: () => import("../views/Settings/TopicsQuestions.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("settings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
      {
        path: "system",
        name: "System",
        component: () => import("../views/Settings/System.vue"),
        async beforeEnter(to, from, next) {
          if (
            (await store.dispatch("authorizationAdminPanel")) &&
            store.getters.visiblePage("settings")
          ) {
            next();
          } else {
            next({ name: "login" });
          }
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: async (to, from, next) => {
      next();
    },
  },
  {
    path: "/documents/license",
    name: "License",
    component: License,
  },
  {
    path: "/documents/soglasie-na-obrabotku-dannyh-152-fz",
    name: "DataProcessingagreement",
    component: DataProcessingAgreement,
  },
  {
    path: "*",
    beforeEnter: async (to, from, next) => {
      if (await store.dispatch("authorizationAdminPanel")) {
        next();
      } else {
        next({ name: "login" });
      }
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
